import { useState, useEffect } from 'react';

export default function useRefresh(time?: number): void {
  const [, setRefresh] = useState<Record<string, never> | undefined>();
  useEffect(() => {
    let timer: ReturnType<typeof setInterval> | undefined;
    if (time) {
      timer = setInterval(() => setRefresh({}), time);
    }
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [time]);
}
